module.exports = __webpack_public_path__ + "img/IMG_2364.e51a23c9.jpg";